import { useMemo, useState } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ListItemButton from "@mui/material/ListItemButton";

type SelectDialogValue = string | number;
interface SelectDialogProps {
  buttonText: string;
  buttonVariant: ButtonProps["variant"];
  buttonProps?: ButtonProps;
  title: string;
  options: unknown[];
  mapOption: (data: unknown) => {
    label: string;
    secondary?: string;
    value: SelectDialogValue;
  };
  onChange: (value: SelectDialogValue) => void;
  value: SelectDialogValue;
}
export const SelectDialog = ({
  buttonText,
  buttonVariant = "outlined",
  buttonProps,
  title,
  options,
  value,
  onChange,
  mapOption,
  ...props
}: SelectDialogProps & Omit<DialogProps, "onClose" | "open">) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleSelect = (value: SelectDialogValue) => {
    onChange(value);
    setOpen(false);
  };
  const mappedOptions = useMemo(
    () => options.map(mapOption),
    [options, mapOption]
  );

  return (
    <>
      <Button
        {...(buttonProps ?? {})}
        variant={buttonVariant}
        onClick={handleOpen}
      >
        {buttonText}
      </Button>
      <Dialog {...props} onClose={handleClose} open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>
          <List>
            {mappedOptions.map((option) => (
              <ListItemButton
                key={option.value}
                selected={value === option.value}
                onClick={() => handleSelect(option.value)}
              >
                <ListItemText
                  primary={option.label}
                  secondary={option.secondary}
                />
              </ListItemButton>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
